/* eslint-disable max-len */
import { useEffect, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { v4 as uuidv4 } from 'uuid';

import { GetMentors } from '../../services/courses';
import { setAnalytics } from '../../utils';

import Chat from './ChatSection/Chat';
import ChatBot from './ChatSection/ChatBot';
import { SideBarMentors } from './MentorSection/SideBarMentors';

const useStyles = makeStyles((theme) => ({
  sidebard: {
    padding: theme.spacing(3, 3),
    margin: theme.spacing(-1, 0, 0, 0),
    background: theme.palette.primary.light,
  },
}));

function ContactMentor() {
  const classes = useStyles();
  const [messages] = useState([]);
  const [mentors, setMentors] = useState();
  const [chatBot, setChatBot] = useState();
  const [chatStatus, setChatStatus] = useState('loading');

  const welcomeMessage = {
    Kami: [
      {
        text: 'Hola soy Kami',
        createdAt: new Date(),
        id: uuidv4(),
      },
      {
        text: 'Puedo ayudarte agendando una reunión con cualquiera de los mentores detallados',
        createdAt: new Date(),
        id: uuidv4(),
      },
      {
        text: 'Por favor indícame con que mentor deseas programar una reunión:',
        alternatives: mentors,
        createdAt: new Date(),
        id: uuidv4(),
      },
    ],
    id: uuidv4(),
  };

  const welcomeMessage1 = {
    Kami: [
      {
        text: 'Hola soy Kami',
        createdAt: new Date(),
        id: uuidv4(),
      },
      {
        text: 'Lamento informarte que en estos momentos todos los mentores ya no cuentan con disponibilidad horaria durante esta semana.',
        createdAt: new Date(),
        id: uuidv4(),
      },
      {
        text: 'Podrás volver a consultar la siguiente semana la disponibilidad horaria de nuestros mentores. Gracias por tu comprensión.',
        createdAt: new Date(),
        id: uuidv4(),
      },
    ],
    id: uuidv4(),
  };

  const getMentors = async () => {
    const obtainedMentors = await GetMentors();
    const existAvailableMentors = obtainedMentors.filter((m) => m.availability.length > 0);

    if (existAvailableMentors.length >= 1) {
      setChatBot(new ChatBot(obtainedMentors));
      setChatStatus('active');
      const nameMentors = obtainedMentors.map((mentor, index) => `${index + 1}. ${mentor.fullName}`);
      nameMentors.push(`${nameMentors.length + 1}. Mejor en otro momento`);
      setMentors(nameMentors);
    } else {
      setMentors([]);
      messages.push(welcomeMessage1);
      setChatStatus('ended');
    }
  };

  if (Array.isArray(mentors) && chatStatus !== 'ended') {
    if (mentors.length >= 1) {
      messages.push(welcomeMessage);
    }
  }

  useEffect(() => {
    getMentors();
    setAnalytics('Home', 'NavPerfil_ContactarMentor');
  }, []);

  return (
    <Grid
      container
      direction="row"
    >
      <Grid item xs={9}><Chat messages={messages} chatBot={chatBot} chatStatus={chatStatus} setChatStatus={setChatStatus} /></Grid>
      <Grid item xs={3} className={classes.sidebard}><SideBarMentors /></Grid>
    </Grid>
  );
}

export default ContactMentor;
